import { connect } from 'react-redux';
import { RootState } from '../../../../redux/store';
import {
  getIsOpen,
  getVisibilityFilters,
  addVisibilityFilter,
  deleteVisibilityFilter,
  setIsOpen,
} from '../../../../redux/templateFilters/slice';
import { VisibilityFilter } from '.';

const mapDispatchToProps = {
  addVisibilityFilter,
  deleteVisibilityFilter,
  setIsOpen,
};

const mapStateToProps = (state: RootState) => ({
  isOpen: getIsOpen(state),
  visibilityFilters: getVisibilityFilters(state),
});

export type VisibilityFiltersProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

export const VisibilityFilterContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(VisibilityFilter);
